import { render, staticRenderFns } from "./FirearmsTransactions.vue?vue&type=template&id=3c3fa76a&scoped=true"
import script from "./FirearmsTransactions.vue?vue&type=script&lang=js"
export * from "./FirearmsTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3fa76a",
  null
  
)

export default component.exports